var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "cate-dialog",
      attrs: {
        width: "350px",
        title: "Add a new Content Category",
        visible: _vm.dialogVisible,
        scrollbar: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "cateForm",
          staticClass: "cate-form",
          attrs: { model: _vm.cateForm, rules: _vm.cateFormRules },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Category Name", prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Please input category name",
                  maxlength: "100",
                },
                model: {
                  value: _vm.cateForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.cateForm, "name", $$v)
                  },
                  expression: "cateForm.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "action-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addCategory } },
            [_vm._v(" Submit ")]
          ),
          _c(
            "el-button",
            {
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }